import React from 'react';
import tinycolor from 'tinycolor2';

const SafariHippo = (props) => {
  const { radius, cells } = props;

  const base = cells[1].background;
  const dark = tinycolor(base).darken(10).toString();

  return (
    
    <svg width={`${radius * 2.75}px`} height={`${radius * 1.48}px`} x={`-${radius * 1.37}px`} y={`-${radius * 1.35}px`} viewBox="0 0 275 148" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Artboard-4">
              <g id="Group-7">
                <path d="M106,0 L106,22 L84,22 C84,9.8497355 93.8497355,0 106,0 Z" fill={dark}></path>
                <path d="M166,0 C178.150264,0 188,9.8497355 188,22 L166,22 L166,0 Z" fill={dark}></path>
                <path d="M75,73 L75,148 L0,148 C0,106.578644 33.5786438,73 75,73 Z" fill={dark}></path>
                <path d="M121,119 L121,144 L96,144 C96,130.192881 107.192881,119 121,119 Z" fill="#EEE9DF"></path>
                <path d="M154,119 C167.807119,119 179,130.192881 179,144 L154,144 L154,119 Z" fill="#EEE9DF"></path>
                <path d="M200,73 C241.421356,73 275,106.578644 275,148 L200,148 L200,73 Z" fill={dark}></path>
                <path d="M37,135 C37,79.771525 81.771525,35 137,35 C192.228475,35 237,79.771525 237,135 L37,135 Z" fill={base}></path>
                <g id="Group" transform="translate(116.000000, 15.000000)" fill="#555">
                    <circle id="Oval" cx="7.5" cy="7.5" r="7.5"></circle>
                    <circle id="Oval-Copy" cx="34.5" cy="7.5" r="7.5"></circle>
                </g>
            </g>
          </g>
        </g>
    </svg>
  )
}
export default SafariHippo;

export function resize(props) {
  const {radius, minY, maxY, minX, maxX} = props;

  return {
    ...props,
    minX: minX + radius * .37,
    maxX: maxX + radius * .37,
    minY: minY + radius * .35,
    maxY: maxY + radius * .13,
  };
}



// WEBPACK FOOTER //
// ./src/core/thematic/safari/hippo.js